/**
 * Tarjousautomaatti launch period (published to every workshop 16.10.2026).
 *
 * Until LAUNCH_ENDS the dashboard quick action carries an "Uutta!" stamp and the dashboard
 * shows the launch info box. Both go quiet by themselves on that date; nothing to clean up.
 */
export const QUOTE_MACHINE_LAUNCH_ENDS = new Date(2026, 10, 1); // 1.11.2026 00:00 local time

export function isQuoteMachineLaunchPeriod(now = new Date()) {
  return now < QUOTE_MACHINE_LAUNCH_ENDS;
}
